<ts-dialog title="Import" (closeDialog)="this.dialogRef.close()">
  <div
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    (dragleave)="onDragLeave($event)"
    class="flex flex-col gap-2 justify-center items-center w-full"
    ts-dialog-body
  >
    <p class="text-2xl font-semibold text-center">
      Drop or
      <span>
        <input hidden type="file" accept=".pdf, .xls, .xlsx" #fileInput (change)="onDrop($event)" />
        <button
          (click)="fileInput.click(); fileInput.value = null"
          class="font-semibold underline cursor-pointer text-primary"
        >
          Select a file
        </button>
      </span>
    </p>

    <p>Import your chart of accounts using the template.</p>
    <a href="https://app.termsheet.com/templates/am-mapping-template.xlsx" class="font-semibold text-primary"
      >Download Template</a
    >
    <div class="h-8 pointer-events-none min-w-1/2">
      @if (fileContainer | async; as fc) {
        @if (fc.selectedFile || fc.draggingOver) {
          <div class="p-2 h-full rounded border border-black-200 bg-black-50">
            @if (fc.selectedFile) {
              <div class="flex flex-row gap-4 justify-between items-center w-auto h-full">
                <p class="w-full font-semibold">{{ fc.selectedFile.name }}</p>
                <ts-icon icon="close" class="w-auto cursor-pointer pointer-events-auto" (click)="clearFile()"></ts-icon>
              </div>
            } @else {
              <div class="flex flex-row justify-center items-center w-full h-full">
                <ts-icon
                  icon="ts_file-import"
                  size="small"
                  color="light-gray"
                  class="w-auto h-full animate-pulse"
                ></ts-icon>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" [disabled]="loading | async" (click)="dialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" [loading]="loading | async" [disabled]="!isSubmitable" (click)="submitForm()"
      >Import</ts-button
    >
  </div>
</ts-dialog>
